type AssignedProps = {
  isSuccess: boolean
}

const Assigned = ({ isSuccess }: AssignedProps) => {
  return (
    <button type="button" className="btn btn-primary" disabled>
      Assigned {isSuccess ? 'Student' : 'Patient'}
    </button>
  )
}

export default Assigned
